export function getTranslationsPage5(newHighSchoolInfo, localizedStrings) {
  newHighSchoolInfo.usb_graduatefromhighschoolincurrentyear.elementConfig.aboveText =
    localizedStrings.applicationpage.expecttograduatefromhighschoolmanitoba;
  newHighSchoolInfo.usb_metnumber.elementConfig.aboveText =
    localizedStrings.applicationpage.provideMETnumber;
  newHighSchoolInfo.usb_schooltype.elementConfig.label =
    localizedStrings.applicationpage.lasthighschoolyouattended;
  newHighSchoolInfo.usb_schoolname0.elementConfig.label =
    localizedStrings.applicationpage.lasthighschoolyouattendedlistofschoolsinmanitoba;
  newHighSchoolInfo.usb_schoolname1.elementConfig.label =
    localizedStrings.applicationpage.lasthighschoolyouattendedfromthelistofschoolsoutsidemanitoba;
  newHighSchoolInfo.usb_schoolname2.elementConfig.label =
    localizedStrings.applicationpage.lasthighschoolyouattendedfromthelistofschoolsoutsidecanada;

  newHighSchoolInfo.usb_graduatefromhighschoolincurrentyear.elementConfig.options =
    newHighSchoolInfo.usb_graduatefromhighschoolincurrentyear.elementConfig.options.map(
      (option) => {
        if (option.value === true) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.yes,
          };
        } else if (option.value === false) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.no,
          };
        }
        return option;
      },
    );

  newHighSchoolInfo.usb_schooltype.elementConfig.options =
    newHighSchoolInfo.usb_schooltype.elementConfig.options.map((option) => {
      if (option.value === 943240000) {
        return {
          ...option,
          displayValue: localizedStrings.applicationpage.manitoba,
        };
      } else if (option.value === 943240001) {
        return {
          ...option,
          displayValue:
            localizedStrings.applicationpage.canadianprovinceotherthanmanitoba,
        };
      } else if (option.value === 943240002) {
        return {
          ...option,
          displayValue: localizedStrings.applicationpage.outsideofcanada,
        };
      } else if (option.value === 943240005) {
        return {
          ...option,
          displayValue: localizedStrings.applicationpage.homeschool,
        };
      }
      return option;
    });

  return newHighSchoolInfo;
}

export function getTranslationsPage5PartTwo(
  newHighSchoolInfo,
  localizedStrings,
) {
  newHighSchoolInfo.start_date_month.elementConfig.label =
    localizedStrings.applicationpage.month;
  newHighSchoolInfo.start_date_year.elementConfig.label =
    localizedStrings.applicationpage.year;
  return newHighSchoolInfo;
}

export function getTranslationsPage5PartThree(
  newHighSchoolInfo,
  localizedStrings,
) {
  newHighSchoolInfo.end_date_month.elementConfig.label =
    localizedStrings.applicationpage.month;
  newHighSchoolInfo.end_date_year.elementConfig.label =
    localizedStrings.applicationpage.year;
  newHighSchoolInfo.usb_graduate.elementConfig.label =
    localizedStrings.applicationpage.didyougraduate;
  newHighSchoolInfo.usb_graduationdate.elementConfig.label =
    localizedStrings.applicationpage.graduationyear;
  newHighSchoolInfo.usb_addtionalcoursescomment.elementConfig.aboveText =
    localizedStrings.applicationpage.addtionalcoursescomment;
  newHighSchoolInfo.usb_graduate.elementConfig.options =
    newHighSchoolInfo.usb_graduate.elementConfig.options.map((option) => {
      if (option.value === true) {
        return {
          ...option,
          displayValue: localizedStrings.applicationpage.yes,
        };
      } else if (option.value === false) {
        return { ...option, displayValue: localizedStrings.applicationpage.no };
      }
      return option;
    });

  return newHighSchoolInfo;
}
